
import { Component, Watch, Vue } from "vue-property-decorator";
import { mapGetters } from "vuex";
import router from "@/router.ts";
import store from "@/store/index.ts";

@Component({
  name: "RequestError",
  computed: {
    ...mapGetters("app", ["isRequestError"])
  }
})
export default class RequestError extends Vue {
  isShow: boolean = false;
  isRequestError;

  @Watch("isRequestError")
  handleRequestErrorChange(e: boolean) {
    this.$emit("isRequestError", e ? "request-error" : "");
    this.isShow = e;
  }

  created() {
    this.initListenerForRouter();
  }

  initListenerForRouter() {
    router.beforeEach((to, from, next) => {
      store.dispatch("app/showRequestError", false);
      next();
    });
  }

  handleReload() {
    location.reload();
  }
}
